/**
 *  Component: Slack Mapping Fields
 */
import React from 'react';

import { Box, Flex } from '@chakra-ui/react';
import { Grid } from '@material-ui/core';
import { Channel, Delete } from '@mesh.ai/rabbit';
import { components } from 'react-select';
import styled from 'styled-components';
import { StyledIconButton } from 'styles/common';

import { SelectDashed } from 'uiToolkitV1/Select';
import { TextBodyMedium } from 'uiToolkitV1/Typography';

import ConnectorLine from './connectorLine';

const IconButton = styled(StyledIconButton)`
  display: table;
  margin: 8px auto 0 24px;
`;

export const ValueContainerWithPrefixChannelIcon = ({ children, ...props }) => (
  <components.SingleValue {...props}>
    <Flex alignItems="center" gap="8px">
      <Channel fontSize="18px" color="#666" />
      <TextBodyMedium>{children}</TextBodyMedium>
    </Flex>
  </components.SingleValue>
);

export const OptionsContainerWithPrefixChannelIcon = ({ children, ...props }) => (
  <components.Option {...props}>
    <Flex alignItems="center" gap="8px">
      <Channel fontSize="18px" color="#666" />
      <TextBodyMedium>{children}</TextBodyMedium>
    </Flex>
  </components.Option>
);

const SlackMappingFields = ({ loading, saveFn, deleteFn, mapping, teams, channels }) => (
  <Grid container>
    <Grid item xs={5}>
      <SelectDashed
        value={mapping.teamId ? teams.filter((team) => team.value === mapping.teamId)[0] : {}}
        handleChange={(data) => saveFn(data.value, 'team', mapping)}
        placeholder="Select Team"
        options={teams}
        isDisabled={loading}
      />
    </Grid>
    <Grid item xs={1} style={{ position: 'relative' }}>
      <ConnectorLine />
    </Grid>
    <Grid item xs={5}>
      <SelectDashed
        value={
          mapping.thirdPartyTeamId ? channels.filter((channel) => channel.value === mapping.thirdPartyTeamId)[0] : {}
        }
        handleChange={(data) => saveFn(data.value, 'channel', mapping)}
        placeholder="Select Channel"
        options={channels}
        isDisabled={loading}
        components={{
          SingleValue: ValueContainerWithPrefixChannelIcon,
          Option: OptionsContainerWithPrefixChannelIcon,
        }}
      />
    </Grid>
    <Grid item xs={1}>
      <Box mb="2">
        <IconButton onClick={() => deleteFn(mapping ? mapping.id : null)}>
          <Delete fontSize="24px" color="#666" />
        </IconButton>
      </Box>
    </Grid>
  </Grid>
);

export default SlackMappingFields;
